import { ButtonHTMLAttributes, FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { ArrowRight } from 'svgIcons'

interface IFProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  className?: string
}

const ExamButton: FC<IFProps> = ({ children, ...props }) => {
  return (
    <StyledWrapper {...props} type="button">
      <span>{children}</span>
      <ArrowRight className="arrow-icon" />
    </StyledWrapper>
  )
}

export default ExamButton

const desktopStyles = css`
  width: 360px;
  height: 60px;
  border-radius: 9px;
  gap: 4px;

  .arrow-icon {
    width: 18px;
    height: 18px;
  }

  > span {
    font-size: 18px;
  }
`

const mobileStyles = css`
  width: 240px;
  height: 48px;
  border-radius: 8px;
  gap: 4px;
  padding: 14px 0;

  .arrow-icon {
    width: 12px;
    height: 12px;
  }

  > span {
    font-size: 14px;
  }
`

const StyledWrapper = styled.button`
  border: none;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  background-color: #ffffff;
  border: 1px solid #004eff;
  color: #004eff;
  &:hover {
    background-color: #e6f0ff;
  }

  > span {
    font-weight: bold;
    line-height: 2.39;
    letter-spacing: -0.72px;
    text-align: center;
  }

  ${({ theme }) => (theme.isMobile ? mobileStyles : desktopStyles)}
`
